import { ReactNode } from "react";
import {
  RouteObject,
  NavigateFunction,
} from "react-router-dom";


export type ReactRouteObject = RouteObject & ReactExtention

export interface CustomProvider {
  children: ReactNode
}

interface ReactExtention {
  ignoreAuth?: boolean
  ignoreSideBar?: boolean
  ignoreHeader?: boolean
  isDev?: boolean
  initialState?: boolean
}

/* eslint-disable no-unused-vars */

export enum RouteParamters {
  token = "token",
  logOut = "logOut",
  sistemaID = "sistemaID",
  urlLocal = "urlLocal",
  lang = "lang",
  ignoreSideBar = "ignoreSideBar",
  ignoreHeader = "ignoreHeader",
  access_token = "access_token",
}

export function Redirect(url: string, paramters?: RouteParamter[], newTab?: boolean) {
  let result = url;

  // Adicionar base path se estivermos em desenvolvimento
  if (import.meta.env.DEV && !url.startsWith('http') && !url.startsWith('/')) {
    // Pega o base path do import.meta.env.BASE_URL
    const basePath = import.meta.env.BASE_URL;
    result = `${basePath}${url}`;
  }

  if (paramters) {
    paramters = paramters.filter(item => item.value !== undefined && item.value !== null);
    if (paramters.length > 0) {
      result = result + "?"
      let par = ""
      paramters.forEach((p, i) => {
        if (i != 0) {
          par = par + "&"
        }
        par = par + p.key + "=" + p.value
      });
      result += par
    }
  }

  if (newTab) {
    return window.open(result, '_blank');
  } else {
    return window.location.replace(result);
  }
}

// Função auxiliar para abrir em nova aba (mais semântica)
export function RedirectNewTab(url: string, paramters?: RouteParamter[], useHashRouting?: boolean) {
  let processedUrl = url;

  // If using hash routing for SPA compatibility
  if (useHashRouting && !url.startsWith('http')) {
    processedUrl = `/#/${url.replace(/^\/+/, '')}`;
  }

  return Redirect(processedUrl, paramters, true);
}


export function NormalizeURL(url: string): { fixedURL: string; hadExtraSlashes: boolean } {
  const fixedURL = url.replace(/([^:])(\/{2,})/g, "$1/");
  return {
    fixedURL,
    hadExtraSlashes: fixedURL !== url,
  };
}

export function FixRouteURL(url: string, route: string): string {
  // Regex para encontrar a parte do domínio (até o primeiro "/")
  const regex = /^(https?:\/\/[^/]+)(\/?.*)$/;

  // Verifica se a URL corresponde ao padrão e extrai o domínio e a parte da rota
  const match = url.match(regex);
  if (match) {
    const domain = match[1]; // Parte do domínio (http://dominio.com)
    const currentPath = match[2]; // Resto da URL após o domínio (pode ser vazio ou ter uma rota)

    // Se a URL já tiver parâmetros ou uma rota, não adiciona barra extra
    return `${domain}/${route}${currentPath}`;
  }

  return url; // Se a URL não estiver no formato esperado, retorna ela como está
}

export function RemoveURLParams() {
  const currentURL = new URL(window.location.href);
  currentURL.search = "";
  window.history.replaceState(null, "", currentURL.href);
  return currentURL.href
}


export function PathName(pathName: string) {
  return pathName.length == 1 && pathName.startsWith("/") ? pathName : pathName.replace("/", "")
}


export interface RouteParamter {
  key: RouteParamters | string,
  value?: string | number | boolean | undefined
}

// Versão com React Router (recomendada para SPAs)
export function RedirectWithRouter(
  navigate: NavigateFunction,
  url: string,
  paramters?: RouteParamter[]
) {
  let path = url.startsWith('/') ? url : `/${url}`;

  if (paramters && paramters.length > 0) {
    const searchParams = new URLSearchParams();
    paramters
      .filter(item => item.value !== undefined && item.value !== null)
      .forEach(p => searchParams.set(p.key, String(p.value)));

    path += `?${searchParams.toString()}`;
  }

  navigate(path);
}